import React from 'react';

/**
 * PublishStateIndicator — Three-dot publish state indicator
 * Spec: design-system.md Section 8 (Publish State Indicator)
 *
 * Three 4px dots with 3px gap. Green (#10B981) when published,
 * muted white (rgba(255,255,255,0.65)) when private. Always has
 * a dark halo for legibility over photographic backgrounds.
 * Doubles as the OverflowMenu trigger in publishable apps.
 *
 * Uses forwardRef and spreads props so Radix's DropdownMenuTrigger
 * asChild can inject its own onClick and ref.
 */
const PublishStateIndicator = React.forwardRef(function PublishStateIndicator(
  { isPublished, overrideOpacity = 1.0, style: styleProp, ...props },
  ref
) {
  const color = isPublished ? '#10B981' : 'rgba(255,255,255,0.65)';

  return (
    <button
      ref={ref}
      type="button"
      {...props}
      style={{
        position: 'absolute',
        top: 10,
        right: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        padding: 0,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        width: 24,
        height: 24,
        justifyContent: 'center',
        opacity: overrideOpacity,
        zIndex: 2,
        ...styleProp,
      }}
      aria-label={isPublished ? 'Published' : 'Private'}
    >
      {[0, 1, 2].map(i => (
        <span
          key={i}
          style={{
            width: 5,
            height: 5,
            borderRadius: '50%',
            backgroundColor: color,
            filter: 'drop-shadow(0 0 2.5px rgba(0,0,0,1))',
            transition: 'background-color 150ms ease',
          }}
        />
      ))}
    </button>
  );
});

export default PublishStateIndicator;
